<!--
  - Copyright (c) 2021. Michael Clovis
  - This program is free software: you can redistribute it and/or modify
  -     it under the terms of the GNU Affero General Public License as published by
  -     the Free Software Foundation, either version 3 of the License, or
  -     (at your option) any later version.
  -
  -     This program is distributed in the hope that it will be useful,
  -     but WITHOUT ANY WARRANTY; without even the implied warranty of
  -     MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  -     GNU Affero General Public License for more details.
  -
  -     You should have received a copy of the GNU Affero General Public License
  -     along with this program.  If not, see <https://www.gnu.org/licenses/>.
  -->

<template>
  <tr>
    <td class="col-3 " @click="clickedName">{{ employee.getFullName() }}</td>
    <schedule-item @show-map="showMap" @choosetoday="chooseToday" @rotachosen="emitRotachosen" :show-pay="showPay"
                   :rota="rota.filter((el)=> {return el != null && el.isOnSameDayAs(moment.clone().add(num,'days'))})"
                   :moment="moment.clone().add(num,'days')" :employee="employee" v-for="num of numbers"
                   :key="num"></schedule-item>
    <schedule-total-column-item

        :employee="employee" :show-pay="showPay"
        :rota="rota.filter((el)=>el.isBetween(moment.clone().add(numbers[0],'days').startOf('day'),
      moment.clone().add(numbers[numbers.length-1],'days').endOf('day')))"

    >

    </schedule-total-column-item>
  </tr>


</template>

<script>
import ScheduleItem from "../components/ScheduleItem";
import {User} from "../classes/User";
import ScheduleTotalColumnItem from "./ScheduleTotalColumnItem";
import {Appointment} from "../classes/Appointment";

export default {
  name: "ScheduleLine",
  created() {
    this.setNumbers();
  },
  data() {
    return {
      numbers: []
    }
  },
  emits: ["rotachosen", "choosetoday", "show-map"],
  methods: {
    getRotaLength(){
      return this.$store.state.appointments.length
    },
    showMap(arg) {
      this.$emit("show-map", arg);
    },
    chooseToday(arg) {
      this.$emit("choosetoday", arg);
    },
    clickedName() {
      let appt = new Appointment();
      appt.User = this.employee;
      this.$emit("rotachosen", appt);
    },
    emitRotachosen(arg) {

      this.$emit("rotachosen", arg);
    },
    setNumbers() {
      let startNum = 0;
      this.numbers = [];
      switch (this.moment.format("dd")) {
        case "Su":
          startNum = 0;
          break;
        case "Mo":
          startNum = -1;
          break;
        case "Tu":
          startNum = -2;
          break;
        case "We":
          startNum = -3;
          break;
        case "Th":
          startNum = -4;
          break;
        case "Fr":
          startNum = -5;
          break;
        case "Sa":
          startNum = -6;
          break;


      }// end switch
      let ctr = 0;
      while (ctr <= 6) {
        this.numbers.push(startNum + ctr);
        ctr++;
      }
    }
  },
  props: {
    employee: {
      type: Object,
      required: true,
      default: new User("test", "", "user"),
    },
    showPay: {
      type: Boolean,
      required: true,
    },
    moment: {
      type: Object,
      required: true,
    },
  },
  components: {ScheduleTotalColumnItem, ScheduleItem},
  computed: {
    rota() {
      //console.log(this.$store.state.appointments.length)
      return this.$store.state.appointments;
    }
  },
}
</script>

<style scoped>

</style>
